import React from 'react';
import {
  Description,
  Euro,
  EventAvailable,
  AccessTime,
} from '@mui/icons-material';

export const steps = [
  { label: 'Prestation', icon: <Description />, desc: 'Détails du service' },
  { label: 'Tarification', icon: <Euro />, desc: 'Prix et accès' },
  {
    label: 'Période de disponibilité',
    icon: <EventAvailable />,
    desc: 'Période de validité',
  },
  { label: ' Horaires', icon: <AccessTime />, desc: 'Créneaux et pauses' },
];

export const DAYS_OF_WEEK = [
  'lundi',
  'mardi',
  'mercredi',
  'jeudi',
  'vendredi',
  'samedi',
  'dimanche',
];

export const inputStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    backgroundColor: '#F9FBFF',
    '& fieldset': { border: '1px solid #E2EBF6' },
    '&:hover fieldset': { borderColor: '#4318FF' },
    '&.Mui-focused fieldset': { borderWidth: '2px', borderColor: '#4318FF' },
  },
  mb: 3,
};

export const getSlotStyle = (status) => {
  switch (status) {
    case 'available':
      return {
        border: '#10B981',
        dot: '#10B981',
        bg: '#DCFCE7',
        text: '#047857',
      };

    case 'reserved':
      return {
        border: '#3B82F6',
        dot: '#3B82F6',
        bg: '#DBEAFE',
        text: '#1D4ED8',
      };

    case 'blocked':
      return {
        border: '#F59E0B',
        dot: '#F59E0B',
        bg: '#FEF3C7',
        text: '#B45309',
      };

    case 'cancelled':
      return {
        border: '#EF4444',
        dot: '#EF4444',
        bg: '#FEE2E2',
        text: '#B91C1C',
      };

    default:
      return {
        border: '#CBD5E1',
        dot: '#94A3B8',
        bg: '#F1F5F9',
        text: '#334155',
      };
  }
};

// Formulaire vierge utilisé à l'initialisation du state (Offres/index.jsx)
export const initialFormData = {
  titre_offre: '',
  description_offre: '',
  type_offre: '',
  duree_offre: 60,
  id_category: '',
  status: true,
  prix_offre: '',
  is_paid_offre: true,
  is_accessible_participant: true,
  date_debut_dispo: '',
  date_fin_dispo: '',
  jours_off: ['samedi', 'dimanche'],
  duree_pause: 15,
  plage_horaire_matin_debut: '09:00',
  plage_horaire_matin_fin: '12:00',
  plage_horaire_aprem_debut: '14:00',
  plage_horaire_aprem_fin: '18:00',
  id_intervenant: '',
  format_offre: '',
  address_ws: '',
  city_ws: '',
  postal_code_ws: '',
  country_ws: '',
  location_note_ws: '',
  lat_ws: '',
  lng_ws: '',
  is_deplacement_possible: false,
};

// Formulaire utilisé par resetForm() : identique au comportement d'origine
// (is_deplacement_possible n'y était pas réinitialisé explicitement).
export const resetFormData = {
  titre_offre: '',
  description_offre: '',
  type_offre: '',
  duree_offre: 60,
  id_category: '',
  status: true,
  prix_offre: '',
  is_paid_offre: true,
  is_accessible_participant: true,
  date_debut_dispo: '',
  date_fin_dispo: '',
  jours_off: ['samedi', 'dimanche'],
  duree_pause: 15,
  plage_horaire_matin_debut: '09:00',
  plage_horaire_matin_fin: '12:00',
  plage_horaire_aprem_debut: '14:00',
  plage_horaire_aprem_fin: '18:00',
  id_intervenant: '',
  lat_ws: '',
  lng_ws: '',
  format_offre: '',
  address_ws: '',
  city_ws: '',
  postal_code_ws: '',
  country_ws: '',
  location_note_ws: '',
};
